import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Input, Typography } from 'antd';

import { StyledForm } from './styled';

interface IProps {
  link: string;
  password?: string;
}

const CopyLinkPassword: FC<IProps> = ({ link, password }) => {
  const { t } = useTranslation();

  return (
    <StyledForm layout="vertical">
      <Form.Item label={t('video_call.link')}>
        <Typography.Paragraph
          className="copy-content"
          copyable={{ text: link }}
        >
          <Input value={link} />
        </Typography.Paragraph>
      </Form.Item>
      {!!password && (
        <Form.Item label={t('video_call.password')}>
          <Typography.Paragraph
            className="copy-content"
            copyable={{ text: password }}
          >
            <Input value={password} />
          </Typography.Paragraph>
        </Form.Item>
      )}
    </StyledForm>
  );
};

export default CopyLinkPassword;
